import { useState } from 'react';
import { EllipsisVerticalIcon } from '@heroicons/react/24/solid';
import LogoutButton from './LogoutButton';

import './OptionsMenu.css'
import SyncButton from './SyncButton';
import ResetButton from './ResetButton';

export default function OptionsMenu() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="options-menu">
      <button 
        className="options-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Options menu"
      >
        <EllipsisVerticalIcon className="menu-icon" width={36} height={36} />
      </button>

      {isOpen && (
        <div className="options-dropdown">
          <SyncButton />
          <ResetButton />
          <LogoutButton />
        </div>
      )}
    </div>
  );
}